import { BonusMessageType } from "../../../../types";
import { getDictPhrase } from "../../../common";
export const getBonusDetailsTax = (bet, state) => {
    return bet.taxes
        .filter(tax => tax.amount > 0)
        .map(tax => {
        return {
            type: BonusMessageType.Tax,
            phrase: getDictPhrase(state.dict, tax.category).format(state.formatCurrency(tax.amount), tax.rate)
        };
    });
};
//# sourceMappingURL=getBonusDetailsTax.js.map